import { HoursComputedInterface, RequestRecord } from './../../../models/request-round/request-record.interface';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RequestRecordFormComponent } from "../request-record-form/request-record-form.component";
import { ToastService } from 'src/app/shared/services/toast-service/toast.service';
import { EventTypeTranslatePipe } from 'src/app/shared/pipes/round-events-translate.pipe';
import { RoundPaymentStatusPipe } from 'src/app/shared/pipes/round-payment-status.pipe';
import { CaregiverRoundDTO } from 'src/app/shared/models/caregiver.model';
import { RequestRecordService } from 'src/app/requests-handling/request-round/request-record-service/request-record.service';
import { takeUntil, map, catchError, of, Subject } from 'rxjs';
import { AlertComponent } from '../../modals/alert/alert.component';

@Component({
  selector: 'app-round-b2b-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RequestRecordFormComponent, EventTypeTranslatePipe, RoundPaymentStatusPipe, AlertComponent],
  templateUrl: './round-b2b-table.component.html',
  styleUrl: './round-b2b-table.component.scss'
})
export class RoundB2bTableComponent implements OnDestroy {

  @Input() rounds!: RequestRecord[];
  @Input() hoursComputed!: HoursComputedInterface;
  @Input() caregiverDTO!: CaregiverRoundDTO;
  @Output() refreshList = new EventEmitter<void>()

  roundsFormArray: FormArray<FormGroup> = this.fb.array<FormGroup>([]);
  activeIndex: number | null = null;
  private unsubscribe$ = new Subject<void>();
  showDeleteConfirm = false;
  recordID!: string | null;
  totalHoursWorked = 0;

  constructor(private fb: FormBuilder, private toast: ToastService, private recordService: RequestRecordService) {}

  updateRecord() {
    this.refreshList.emit()
  }

  deleteRound(event: Event, recordId: string) {
    event.preventDefault();
    event.stopPropagation();
    this.showDeleteConfirm = true;
    this.recordID = recordId;
  }

  confirmDelete(event: boolean) {
    if (event === true && this.recordID) {
      this.recordService.deleteRecord(this.recordID).pipe(
        takeUntil(this.unsubscribe$),
        map(() => this.toast.setAction('Round aggiornato con successo!', true)),
        catchError(() => {
          this.toast.setAction("Errore durante l'eliminazione del round!", false)
          return of()
        })
      ).subscribe(() => {
        this.refreshList.emit()
        this.recordID = null;
        this.showDeleteConfirm = false;
      })
    } else {
      this.showDeleteConfirm = false;
    }
  }

  toggleForm(i: number | null): void {
    this.activeIndex = this.activeIndex === i ? null : i;
  }

  onCopyClick(event: Event, paymentLink: string): void {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(paymentLink)
      .then(() => this.toast.setAction('Link di pagamento copiato con successo', true))
      .catch((err) => this.toast.setAction('Errore durante la copia del link di pagamento', false))
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete()
  }
}
